import React from 'react';
import { InvestorShare } from '../../../types/analytics.types';
import { fmt, formatCurrency } from '../../../utils/formatters';

interface Props {
  shares: InvestorShare[];
}

const InvestorsCapitalShare: React.FC<Props> = ({ shares }) => {
  if (shares.length === 0) return null;

  return (
    <div className="analytics-section">
      <h3 className="analytics-section-title">Investors Capital Share</h3>
      <div className="analytics-table-wrapper">
        <table className="analytics-table">
          <thead>
            <tr>
              <th className="text-left">Investor</th>
              <th className="text-right">Profit</th>
              <th className="text-right">Balance</th>
            </tr>
          </thead>
          <tbody>
            {shares.map((s) => (
              <tr key={s.name}>
                <td className="text-left">
                  <div className="investor-name">{s.name}</div>
                  <div className="investor-subtitle">
                    {fmt(s.ownershipPct, 1)}% — Invested: ${fmt(s.netInvested, 0)}
                  </div>
                </td>
                <td className={`text-right nowrap font-bold ${s.profitLoss >= 0 ? 'positive' : 'negative'}`}>
                  {s.profitLoss >= 0 ? '+' : ''}{formatCurrency(s.profitLoss)}
                </td>
                <td className={`text-right nowrap ${s.currentValue >= s.netInvested ? 'positive' : 'negative'}`}>
                  ${fmt(s.currentValue)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvestorsCapitalShare;
